import React, { useEffect, useState } from "react";
import { toast } from "sonner";

const btn = "font-display tracking-[0.18em] text-[11px] uppercase px-3 py-2 border transition-colors disabled:opacity-50";
const fmt = (iso) => iso ? new Date(iso).toLocaleString("nb-NO", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" }) : "—";
const LABEL = { active: "aktiv", pending: "venter på bekreftelse", unsubscribed: "avmeldt" };

export const NewsletterPanel = ({ ax }) => {
  const [d, setD] = useState(null);
  const [busy, setBusy] = useState(false);
  const [open, setOpen] = useState(false);
  const load = () => ax.get("/admin/newsletter").then(({ data }) => setD(data)).catch(() => {});
  useEffect(() => { load(); }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const sendNow = async () => {
    if (!window.confirm("Sende ukesbrevet nå til alle aktive abonnenter?")) return;
    setBusy(true);
    try { const { data } = await ax.post("/admin/newsletter/send-now"); toast.success(`Norsk: ${data.no} · Engelsk: ${data.en}`); load(); }
    catch (e) { toast.error("Utsending feilet."); } finally { setBusy(false); }
  };
  const preview = async (lang, kind = "preview") => {
    const { data } = await ax.get(`/admin/newsletter/${kind}?lang=${lang}`, { responseType: "text" });
    const w = window.open("", "_blank"); if (w) { w.document.write(data); w.document.close(); }
  };
  const remove = async (email) => {
    if (!window.confirm(`Slette ${email} helt?`)) return;
    await ax.delete(`/admin/newsletter/${encodeURIComponent(email)}`); load();
  };
  if (!d) return null;
  return (
    <div data-testid="newsletter-panel" className="border border-edge p-4 space-y-3">
      <div className="flex items-center justify-between gap-3 flex-wrap">
        <div>
          <div className="font-display tracking-[0.18em] text-[11px] uppercase text-coolwhite">Nyhetsbrev · hver fredag 09:00</div>
          <div data-testid="newsletter-counts" className="mt-1 font-term text-[12px] text-dim">
            <span className="text-l3">{d.counts.active} aktive</span> · {d.counts.pending} venter · {d.counts.unsubscribed} avmeldt
            {d.runs[0] ? ` · sist sendt ${fmt(d.runs[0].sent_at)} (${d.runs[0].sent} mottakere)` : " · ikke sendt ennå"}
          </div>
        </div>
        <div className="flex gap-2 flex-wrap">
          <button data-testid="newsletter-preview-no" onClick={() => preview("no")} className={`${btn} border-edge text-coolwhite`}>forhåndsvis NO</button>
          <button data-testid="newsletter-preview-en" onClick={() => preview("en")} className={`${btn} border-edge text-coolwhite`}>forhåndsvis EN</button>
          <button data-testid="newsletter-welcome-preview" onClick={() => preview("no", "welcome-preview")} className={`${btn} border-edge text-coolwhite`}>velkomst-e-post</button>
          <button data-testid="newsletter-list-toggle" onClick={() => setOpen(!open)} className={`${btn} border-edge text-coolwhite`}>{open ? "skjul liste" : "vis abonnenter"}</button>
          <button data-testid="newsletter-send-now" disabled={busy || !d.counts.active} onClick={sendNow} className={`${btn} border-l3 text-l3 hover:bg-l3 hover:text-space`}>{busy ? "…" : "send nå"}</button>
        </div>
      </div>
      {open && (
        <ul data-testid="newsletter-subs" className="divide-y divide-edge max-h-72 overflow-auto">
          {d.subs.length === 0 && <li className="py-2 font-term text-[12px] text-dim">// ingen ennå</li>}
          {d.subs.map((s) => (
            <li key={s.email} className="py-2 flex items-center justify-between gap-3 font-term text-[12px]">
              <span className="text-coolwhite break-all">{s.email} <span className="text-dim">· {s.lang} · {LABEL[s.status]} · {fmt(s.confirmed_at || s.created_at)}</span></span>
              <button onClick={() => remove(s.email)} className={`${btn} border-edge text-coolwhite/85 hover:text-nettred`}>slett</button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};
